<template>
  <div style="height:25%">
    <div class="devideLine"></div>
    <div class="flex panel" style="height:100%">
      <div class="panelLeft">
        <img src="~images/index/home/y1.png" alt="" />
        <img src="~images/index/home/y2.png" alt="" />
        <img src="~images/index/home/y3.png" alt="" />
        <div>
          <p>
            <span class="num">{{ zhcg }}</span>
          </p>
          <p>成果</p>
        </div>
      </div>
      <div class="panelRight flex">
        <div v-for="(item, index) in list" :key="index">
          <!-- <img src="~images/index/home/sline1.png" alt="" /> -->
          <img :src="item.img" alt="" />
          <div>
            <p>{{ item.name }}</p>
            <p>
              <span class="num">{{ item.value }}</span
              >({{ item.unit }})
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getScreenV2DataProcessNew } from "@/api/home";
export default {
  data() {
    return {
      zhcg: "",
      list: [
        {
          name: "开发新产品数量",
          value: 2,
          unit: "个",
          img: require("images/index/home/sline1.png")
        },
        {
          name: "应用新技术数量",
          value: 1,
          unit: "个",
          img: require("images/index/home/sline2.png")
        },
        {
          name: "新增品牌数量",
          value: 1,
          unit: "个",
          img: require("images/index/home/sline3.png")
        },
        {
          name: "新增装备及生产线数量",
          value: 1,
          unit: "台/套",
          img: require("images/index/home/sline4.png")
        }
      ]
    };
  },
  mounted() {
    this.dataLoad();
  },
  methods: {
    dataLoad() {
      getScreenV2DataProcessNew().then(res => {
        let datas = res.zbData;
        this.list[0].value = datas.kfxcp;
        this.list[1].value = datas.yyxjs;
        this.list[3].value = datas.xzzbs;
        this.list[2].value = datas.xzpps;
        let _all = 0;
        this.list.forEach(e => {
          _all += e.value;
        });
        this.zhcg = _all;
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/styl/varibles.styl'
.panel
  height 100%
  font-size 0.06rem
  width 90%
  margin 0 auto
  div
    position relative
.panelLeft
  position relative
  div
    font-size .06rem
    color #fff
    position absolute
    top 50%
    left 50%
    transform translate(-50%,-50%)
    span
      color #00FEDD
      font-size .15rem
      margin-bottom .05rem
  img
    position absolute
    width 100%
    top 0
    left 0
  img:nth-child(1)
    animation ro2 5s linear infinite
    position relative
  img:nth-child(2)
    animation ro 6s linear infinite
  img:nth-child(3)
    animation ro 7s linear infinite
@keyframes ro
  0%
    transform rotate(0deg)
  100%
    transform rotate(365deg)
@keyframes ro2
  0%
    transform rotate(365deg)
  100%
    transform rotate(0deg)

.panelRight
  flex-wrap wrap
  justify-content space-around
  padding-left .1rem
  >div
    width 43%
    display flex
    justify-content flex-start
    box-sizing border-box
    padding .05rem 0 .05rem .05rem

    p
      font-size .06rem

    img
      margin-right .05rem

    span
      color #01CDE6
      font-size .1rem
      margin-right .05rem

.devideLine
  height 2px
  background linear-gradient(to right, transparent, #0B305C, #155782, #0B305C, transparent)
</style>
